import { createContext, useContext, useState, ReactNode } from 'react'
import Tag from '@interfaces/tag.interface'

interface TagsContextType {
  tags: Tag[]
  setTags: (tags: Tag[] | ((prev: Tag[]) => Tag[])) => void
}

const TagsContext = createContext<TagsContextType | undefined>(undefined)

export function TagsProvider({ children }: { children: ReactNode }) {
  const [tags, setTags] = useState<Tag[]>([])

  return <TagsContext.Provider value={{ tags, setTags }}>{children}</TagsContext.Provider>
}

/**
 * Use the tags context
 * @returns The tags context
 */
export function useTags() {
  const context = useContext(TagsContext)
  if (context === undefined) {
    throw new Error('useTags must be used within a TagsProvider')
  }
  return context
}
